export const actionOption = (consentStatus, fetchType, requestSessionId) => {
	switch (consentStatus) {
		case 'ACCEPTED':
			if (fetchType === 'ONETIME' && requestSessionId) return 'View Data';
			else return 'Get Data';
		case 'DATA_REQUESTED':
			if (fetchType === 'ONETIME' && requestSessionId) return 'View Data';
			else return 'Refresh Data Status';
		case 'DATA_READY':
			return 'View Data';
		default:
			return 'No Consent';
	}
};
